// Utils
import { containsPoint, isOverlapping } from '../../../../../common/maths/geometry/rect';

export default ({ targetRect, targetPoint, layerRect }) =>
    targetPoint ? !containsPoint(layerRect, targetPoint) : !isOverlapping(layerRect, targetRect);
